<la-loader mode="pulsing-logo"></la-loader>
